import { JSX } from 'react';
import { Modal } from '@bg-components/Modal';
import { ModalHeader } from '@bg-components/Modal/ModalHeader';
import { ModalClose } from '@bg-components/Modal/ModalClose';
import { ModalContent } from '@bg-components/Modal/ModalContent';
import { Content } from '@bg-components/Modals/GameLimitsModal/Content';
import { fadeAnimation } from '@bg-components/Modals/constants/fadeAnimation';
import { ModalName, IModalProps, t, ISkywardGameId } from '@bg-shared';
import classes from '../styles/SkywardModalsClasses.module.scss';

interface IProps extends IModalProps {
    gameId?: ISkywardGameId;
}

export const GameLimitsModal = (props: IProps): JSX.Element => (
    <Modal
        modalName={ModalName.GAME_LIMITS}
        showBackdrop
        className={classes.modal}
        onClose={props.onClose}
        animation={fadeAnimation}
    >
        <ModalHeader className={classes.header}>
            {t.string('game_limits')}
            <ModalClose className={classes.close} onClose={props.onClose} />
        </ModalHeader>
        <ModalContent className={classes.content}>
            <Content gameId={props.gameId} />
        </ModalContent>
    </Modal>
);
